import { ftCurrentTruthSink, type LocalTruthSink } from '../shared/truth-sink';
import { ftClockCalendarFromArr, ftClockCampaignField, type CampaignClockCols } from '../shared/campaign-clock';
import { resolveCalendarCatchup } from '../janus-engine/turns/calendar-catchup';
import { turnReaders } from './turn-truth';
import { finishDueTimedActivities } from './timed-finish-truth';
import { ecId, type Row } from '../janus-engine/ability/context';
import { dueTimedActivities } from '../janus-engine/ability/timed-finish';

/** Practice changes only its held checkpoint, then uses the ordinary paused-calendar expiry and activity observer. */
export async function advancePracticeClock(encounterId: string, clock: CampaignClockCols): Promise<void> {
    const sink = ftCurrentTruthSink() as LocalTruthSink | null;
    if (!sink?.patchClock || !sink.heldBase?.(encounterId)) throw new Error('The practice clock is unavailable.');
    await sink.patchClock(clock);
    const encounter = sink.surface, roster = encounter.encounter_creatures_arr as Row[];
    const read = turnReaders(encounter, clock);
    const tick = resolveCalendarCatchup({ encounter, roster, clock, calendar: ftClockCalendarFromArr(encounter.campaign_arr),
        read, calendarOnly: true, facts: { history: sink.logs, awakeNotices: [] } });
    if (tick.rows.length || Object.keys(tick.ec).length || tick.statusesAdded.length || tick.statusesRemoved.length
        || tick.statusesChanged.length || tick.charges.length || tick.spawnRows?.writes.length) {
        const command = { schema: 'janus.time.push.v1', operation_id: crypto.randomUUID().toUpperCase(), encounter_id: encounterId,
            campaign_id: ftClockCampaignField(encounter.campaign_arr, 'campaign_id'),
            actor_id: roster[0] ? ecId(roster[0]) : '', expected: { clock }, frame: { rows: {} }, tick };
        await sink.commit(command, command.frame);
    }
    await finishDueTimedActivities({ encounterId, scope: { kind: 'ooc' }, clock });
    if (dueTimedActivities(sink.surface.encounter_creatures_arr as Row[], clock, 'all').length)
        throw new Error('The activity is still waiting for a condition before it can finish.');
}

Object.assign(window, { ftAdvancePracticeClock: advancePracticeClock });
